

























import { Component, Mixins } from 'vue-property-decorator';
import Icon from '../../../generic/Icon.vue';
import GenericInput from '../../../generic/forms/Input.vue';
import LoginMixin from '../abstracts/LoginMixin';
import { GitLabGateway } from 'ganttlab-gateways';
import { Credentials } from 'ganttlab-entities';

@Component({
  components: {
    Icon,
    GenericInput,
  },
})
export default class Login extends Mixins(LoginMixin) {
  // implementing abstract defaultCredentials with appropriate structure
  public defaultCredentials: Credentials = {
    instance: 'https://gitlab.com',
    token: '',
  };

  // implementing abstract getSourceGateway
  getSourceGateway() {
    return new GitLabGateway();
  }

  // from there, this logic is totally specific to the GitLab Login vue
  get personalTokenLink() {
    if (this.credentials.instance) {
      return `${this.credentials.instance.replace(
        /\/$/,
        '',
      )}/-/profile/personal_access_tokens`;
    }
    return null;
  }
}
